/* Add on Flyout Section(Global Variable Initialization) */
/* Final Selected Products */
var selectedProductsData = [] 
/* Checked Products Data */
var checkedProductData = [] 
/* Final Selected Products */
var selectedStackProductsData = [] 
/* Checked Products Data */
var checkedStackProductData = [] 
/* Final Values to add */
var selectedStackVariantIds = []

var characterMatches = currentProductJson ? currentProductJson.tags.filter(s => s.includes('c-')) : [];
var characterMatchesOptional = currentProductJson ? currentProductJson.tags.filter(s => s.includes('c2-')) : [];
var characterMatchesOptionalThree = currentProductJson ? currentProductJson.tags.filter(s => s.includes('c3-')) : [];
var engravableMatches = currentProductJson ? currentProductJson.tags.filter(s => s.includes('Engravable')) : '';
var engravablePlacementMatches = currentProductJson ? currentProductJson.tags.filter(s => s.includes('Engravable-placement')) : '';
var engravablePlacementOptionsMatches = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engraving-placement-options')) : [];
var engravableStyleOptionsMatches = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engraving-style-options')) : [];
var engravableOptional = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engraving-optional')) : [];
var engravableOptionalThree = currentProductJson ? currentProductJson.tags.filter(s => s.includes('engraving-optional-three')) : [];

if (characterMatches && characterMatches != '') {
  characterMatches = characterMatches[0].replace("c-", "");
} else if (characterMatches && characterMatches == '') {
  characterMatches = 40;
}
if (characterMatchesOptional && characterMatchesOptional != '') {
  characterMatchesOptional = characterMatchesOptional[0].replace("c2-", "");
} else if (characterMatchesOptional && characterMatchesOptional == '') {
  characterMatchesOptional = 12;
}

if (characterMatchesOptionalThree && characterMatchesOptionalThree != '') {
  characterMatchesOptionalThree = characterMatchesOptionalThree[0].replace("c3-", "");
} else if (characterMatchesOptionalThree && characterMatchesOptionalThree == '') {
  characterMatchesOptionalThree = 2;
}

function changeInputNumbers() {
  var charCount = $("#input-text-engraving-styles").val().length;
  var charCountOptional = $("#input-text-engraving-styles-optional").val()?.length;
  var charCountOptionalThree = $("#input-text-engraving-styles-optional-three").val()?.length;
  var charVal = $("#input-text-engraving-styles").val();
  var charValOptional = $("#input-text-engraving-styles-optional").val();
  var charValOptionalThree = $("#input-text-engraving-styles-optional-three").val();
  var charTwoVal = $("#engravable_placement_dropdown_input_box").val();
  var grabFontFamily = $("#selected-engravable-font").text().trim();
  if(engravablePlacementMatches.length === 0 && engravableStyleOptionsMatches.length === 0) {
    $("#charCountEnraging").html(charCount + '/' + characterMatches);
  }
  (charCount !== 0) ? $("#fontFamilyPreview").removeClass("hide") : $("#fontFamilyPreview").addClass("hide");
  if(engravableOptional !== 0) $("#charCountEnragingOptional").html(charCountOptional + '/' + characterMatchesOptional);
  if(engravableOptionalThree !== 0) $("#charCountEnragingOptionalThree").html(charCountOptionalThree + '/' + characterMatchesOptionalThree);
  var uppercaseValue = charVal
  var upperCaseValueTwo = charTwoVal
  if (grabFontFamily === "Celine") {
    uppercaseValue = charVal.toUpperCase();
    upperCaseValueTwo = charTwoVal.toUpperCase();
    charValOptional = charValOptional?.toUpperCase();
    charValOptionalThree = charValOptionalThree?.toUpperCase();
  }
  $("#engravingText").val(uppercaseValue);
  $("#engravingTextTwo").val(upperCaseValueTwo);
  $("#engravingTextOptional").val(charValOptional);
  $("#engravingTextOptionalThree").val(charValOptionalThree);
  $("#fontFamilyPreview").html(uppercaseValue);
  $("#fontFamilyPreviewTwo").html(upperCaseValueTwo);
  $("#fontFamilyPreviewOptional").html(charValOptional);
  $("#fontFamilyPreviewOptionalThree").html(charValOptionalThree);
}

/* Disabling input box */
var engravingTextInput = document.getElementById('input-text-engraving-styles');
if (engravingTextInput) {
  Object.defineProperty(engravingTextInput, 'disabled', { value: true, writable: false });
}
/* Enable Disable Engravable Styles */
var engravableChecked = false;
var updateEngraveCompareAtPrice;
var updateEngraveRegularPrice;
var updateEngraveSalePrice;
$("#engravablesInputsWrapperSlider").click(function () {
  if ($('#engravablesInputsWrapper').is(":checked")) {
    $("#fontFamilyPreview").addClass("hide");
    engravableChecked = false;
    engravableDropDown(currentVariantJson)
    $(".engravable_placement_dropdown_input_box").val("");
    $(".Customization-DropDown-Placement").addClass("hide");
    $("#input-text-engraving-styles").attr("disabled", "disabled").val("").attr("maxlength", "0");
    $("#input-text-engraving-styles-optional").attr("disabled", "disabled").val("");
    $("#input-text-engraving-styles-optional-three").attr("disabled", "disabled").val("");
    $(".engraving-wrapper, .engravable-dropdown, .engravable-placement-dropdown").addClass("disabled_fields");
    $("#engravableInputField").attr("disabled", "disabled");
    $('form[action="/cart/add"]').find("input[name='properties[_engraving_required]']").val("No");
    $(".engravable-dropdown").find("span.ProductForm__SelectedValue").html("Select your font")
    $(".engravable-placement-dropdown").find("span.dropdown-selected-value").html("Select")
    if(engravablePlacementMatches.length === 0 && engravableStyleOptionsMatches.length === 0) {
      $("#charCountEnraging").html('0/' + characterMatches);
      $("#input-text-engraving-styles").attr("maxlength", characterMatches);
    } else {
      $("#charCountEnraging").html('0/0');
    }
    $("#fontFamilyPreview, #fontFamilyPreviewOptional, #fontFamilyPreviewOptionalThree").css("font-family", "").html("");
    $("#engravingFont").remove();
    $("#engravingText").remove();
    $("#engravingTextTwo").remove();
    $("#fontFamilyPreviewTwo").remove();
    $("#engravingPlacement").remove();
    $(".engravable_drop_down, .engravable_placement_drop_down").attr("disabled", "disabled");
    $('.engravable-error').text('').removeClass('open').addClass('hide')
    $('.engravable-text-error').text('').removeClass('open').addClass('hide')
    $('.engravable-text-two-error').text('').removeClass('open').addClass('hide')
    $("input[name='properties[_excludeFromNarvar]']").val("no")
    $('.ProductForm__AddToCart').find('.jsAddtocartFinalSale').remove();
    if ($('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).length > 0) {
      $('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).attr("value", '')
    } else {
      $('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).attr("value", '')
    }
    $('.ProductForm__AddToCart').attr('onclick', "selectedVariantImage('" + variantImage + "')");
    if (originalLeadTimeMsg && originalLeadTimeMsg !== "") {
      $(".stock-level-message").text(originalLeadTimeMsg);
      if (originalLeadTimeMsg.indexOf("Only a few left!") !== -1 || originalLeadTimeMsg.indexOf("In Stock") !== -1){
        $('.inv-label--out-stock').addClass('hide')
        $('.inv-label--in-stock').removeClass('hide')
      } 
      if (originalLeadTimeMsg.indexOf("Only a few left!") === -1 && originalLeadTimeMsg.indexOf("In Stock") === -1){
        $('.inv-label--out-stock').removeClass('hide')
        $('.inv-label--in-stock').addClass('hide')
      } 
      if (originalLeadTimeMsg.indexOf("Sold Out") !== -1){
        $('.inv-label--out-stock').addClass('hide')
        $('.inv-label--in-stock').addClass('hide')
        disableAddToCartButton();
      }
    }
    if(currentVariantJson && currentVariantJson.compare_at_price && $('#appendCompareAt').text().length){
      var addEngraveComparePrice = (updateEngraveCompareAtPrice - 30);
      $('#appendCompareAt').text('$' + addEngraveComparePrice);
    }
    if(currentVariantJson && currentVariantJson.price && $('#appendReg').text().length){
      var addEngraveRegPrice = (updateEngraveRegularPrice - 30).toFixed(2);
      $('#appendReg').text('$' + addEngraveRegPrice);
    }
    if(currentVariantJson && currentVariantJson.price && $('#appendSale').text().length){
      var addEngraveSalePrice = (updateEngraveSalePrice - 30);
      $('#appendSale').text('$' + addEngraveSalePrice.toFixed(2));
    }
    $('.stock-status--wrapper').css('height','20px')
    // enableAddToCartButton();
  } else {
    $('.ProductForm__AddToCart').removeAttr('onclick');
    if(currentVariantJson && currentVariantJson.compare_at_price && $('#appendCompareAt').text().length){
      var compareAtPrice = parseFloat(currentVariantJson.compare_at_price);
      updateEngraveCompareAtPrice = formatPriceFunc((compareAtPrice/100) + 30);
      $('#appendCompareAt').text('$' + updateEngraveCompareAtPrice);
    } 
    if(currentVariantJson && currentVariantJson.price && $('#appendReg').text().length){
      var regularPrice = parseFloat(currentVariantJson.price);
      updateEngraveRegularPrice = formatPriceFunc((regularPrice/100) + 30);
      updateEngraveRegularPrice = parseFloat(updateEngraveRegularPrice).toFixed(2);
      $('#appendReg').text('$' + updateEngraveRegularPrice);
    } 
    if(currentVariantJson && currentVariantJson.price && $('#appendSale').text().length){
      var priceWithDollarSign = $('#appendSale').text();
      var priceWithoutDollarSign = priceWithDollarSign.replace('$', '');
      updateEngraveSalePrice = (parseFloat(priceWithoutDollarSign) + 30);
      $('#appendSale').text('$' + updateEngraveSalePrice.toFixed(2));
    } 
    if (currentProductJson.id !== 8005498110040) engravableChecked = true;
    engravableDropDown(currentVariantJson)
    if ($('form[action="/cart/add"]').find(".jsAddtocartFinalSale").length == 0) {
      $('.ProductForm__AddToCart').append(`<span class="jsAddtocartFinalSale addtocart-final-sale"></span>`)
    }
    if (currentProductTemplate !== 'default-2-0-meta-teaser') {
      var msg = "(Final Sale!)"
      $('.ProductForm__AddToCart').find('.jsAddtocartFinalSale').text(msg)
      var isFinalSaleElementPresent = $('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).length
      if (isFinalSaleElementPresent > 0) {
        $('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).attr("value", msg)
      } else {
        $('form[action="/cart/add"]').find(`input[name="properties[Final_Sale]"]`).attr("value", msg)
        $('form[action="/cart/add"]').append(`<input type="hidden" name="properties[Final_Sale]" value='${msg}'/>`)
      }
    }
    if (engravablePlacementMatches[0] === 'Engravable-placement' && $('form[action="/cart/add"]').find(`input[name="properties[_engravingplacement]"]`).length === 0) {
      $('form[action="/cart/add"]').append(`<input type="hidden" id="engravingPlacement" class="engravable_placement_option_value" name="properties[_engravingplacement]" value=''/>`)
    }
    $("#input-text-engraving-styles").removeAttr("disabled", "disabled");
    $("#input-text-engraving-styles-optional").removeAttr("disabled", "disabled");
    $("#input-text-engraving-styles-optional-three").removeAttr("disabled", "disabled");
    $(".engraving-wrapper, .engravable-dropdown, .engravable-placement-dropdown").removeClass("disabled_fields");
    $("#engravableInputField").removeAttr("disabled", "disabled");
    $('form[action="/cart/add"]').find("input[name='properties[_engraving_required]']").val("Yes");
    $(".engravable_drop_down, .engravable_placement_drop_down").removeAttr("disabled", "disabled");
    $("#engravingFont").attr("data-required", "true");
    $("#engravingText").attr("data-required", "true");
    if (engravablePlacementMatches[0] === 'Engravable-placement') $("#engravingPlacement").attr("data-required", "true");
    // disableAddToCartButton();
    $("input[name='properties[_excludeFromNarvar]']").val("yes");
    var leadTimeEngFromUi = originalLeadTimeMsg.replace(/\s+/g, "");
    if (leadTimeEngFromUi.indexOf("instock") !== -1 || leadTimeEngFromUi.indexOf("InStock") !== -1 ||
      leadTimeEngFromUi.indexOf("pieceleft!") !== -1 || leadTimeEngFromUi.indexOf("piecesleft!") !== -1 ||
      leadTimeEngFromUi.indexOf("Onlyafewleft!") !== -1) {
      $(".stock-level-message").text("In Stock. Please add an additional 2-3 weeks for engraving.");
      $('.inv-label--out-stock').addClass('hide')
      $('.inv-label--in-stock').removeClass('hide')
    } else {
      $(".stock-level-message").text(originalLeadTimeMsg + " Please add an additional 2-3 weeks for engraving.");
      $('.inv-label--out-stock').removeClass('hide')
      $('.inv-label--in-stock').addClass('hide')
    }
    $('.stock-status--wrapper').css('height','40px')
    if (originalLeadTimeMsg.indexOf("Sold Out") !== -1){
      $('.inv-label--out-stock').addClass('hide')
      $('.inv-label--in-stock').addClass('hide')
      disableAddToCartButton();
    }
  }
});

/* Stop input to type Emoji character in Engravable Styles */
$('#input-text-engraving-styles').on('input', function (event) {
  var input = $(this).val();
  var sanitizedInput = input.replace(/[^a-zA-Z0-9 !\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~\u0020-\u007E]/g, '');
  $(this).val(sanitizedInput);
  var key = String.fromCharCode(event.which || event.charCode);
  var regex = /^[a-zA-Z0-9\s!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~\u0020-\u007E]+$/;
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
});

/** Engraving font Produucts functionality implementation **/
var attrs = {
  maxLengthTemplate: "data-maxlength-template",
}

$.fn.maxlength = function (options) {
  var settings = $.extend({}, $.fn.maxlength.defaults, options);
  this.each(function () {
    var ele = $(this);
    insertTemplate(ele, settings);
    ele.on("keyup", settings, keyup);
    ele.on("paste", settings, paste);
  });
  return this;
};

function insertTemplate(ele, settings) {
  // $(settings.template).attr(attrs.maxLengthTemplate, "true").insertBefore(ele);
}

function show(event, length, maxLength) {
  // $(event.target).prev("[" + attrs.maxLengthTemplate + "='true']").text(format(event.data.text, length, maxLength));
}

function format(text, length, maxLength) {
  return text.replace("{total}", length).replace("{maxLength}", maxLength);
}

function keypress(event) {
  var key = (event.keyCode ? event.keyCode : event.which);
  var length = this.value.length;
  var maxLength = $(event.target).attr("maxlength");
  if (key >= 33 || key == 13 || key == 32) {
    if (length >= maxLength)
      event.preventDefault();
  }
}

function keyup(event) {
  var length = this.value.length;
  show(event, length, $(event.target).attr("maxlength"));
}

function paste(event) {
  var pastedData = event.originalEvent.clipboardData.getData('text') ? event.originalEvent.clipboardData.getData('text')
    : event.originalEvent.clipboardData.getData('text/plain');
  var maxlength = $(event.target).attr("maxlength");
  var length = pastedData.length > maxlength ? maxlength : pastedData.length;
  show(event, length, maxlength);
}

function updCharLimit(elem) {
  // var targetElem = $(elem).find(".line-item-property__field input.vow-form-control-light");
  // $(targetElem).each(function (i, element) {
  //   var maxLength = $(element).attr('maxlength');
  //   var length = $(element).val().length;
  //   var prevElem = $(element).prev("[" + attrs.maxLengthTemplate + "='true']");
  //   $(prevElem).text(length + "/" + maxLength);
  // });
}

function getFont(elem) {
  if ($(".ProductForm__Option").length) {
    $(elem).parent().addClass('showlabel');
  }
  if ($(".Engraving .ProductForm__SelectedValue").length) {
    var fonttrim = $(".Engraving .ProductForm__SelectedValue").text();
    var font = fonttrim.replace(/\s+/g, '');
    // Condition for updating the font family from BernhardTango to BernhardTangoBT.
    if (fonttrim == 'Bernhard Tango') {
      font = "BernhardTangoBT";
    };
    $('#customization').val('')
  }
  // Condition for product without engraving dropdown.
  if (!$('.ProductForm__Option').hasClass("Engraving")) {
    var fontget = $("#js-customization-required + .customization-error + .preview-text").attr('style');
  }
}

$("#customization").on("keyup", function(event) {
  event.stopImmediatePropagation();
  var currentValue = $(this).val();
  var currentValueLength = $(this).val().length;
  var maxlength = $(this).attr("maxlength");
  var textStyle = "none";
  var assignFont = currentProductJson ? currentProductJson.tags.filter(s => s.includes('assign-font-')) : "";
  if(assignFont && assignFont != ''){
    assignFont = assignFont[0].replace("assign-font-","");
  }
  
  $("#customization_count").val(maxlength);
  $("#charCountCustomization").text(currentValueLength+"/"+maxlength);
  var fontValue = $("input[name='properties[Font]']").val();
  if(fontValue?.toLowerCase() === "bernhard tango"){
    fontValue = "BernhardTangoBT"
  } else if(fontValue?.toLowerCase() === "celine"){
    fontValue = "BV Celine"
    textStyle = "uppercase"
  } else if (fontValue?.toLowerCase() === "seagram") {
    fontValue = "Seagramtfb";
  } else {
    fontValue = fontValue?.replace(/\s/g, "");
  }
  if (fontValue && fontValue.length > 0) {
    $(".fontPreviewCustomize").text(currentValue).css("font-family",fontValue).css('text-transform',textStyle);
  } else {
    if(assignFont?.toLowerCase() === "bernhard tango"){
    assignFont = "BernhardTangoBT"
    } else if(assignFont?.toLowerCase() === "celine"){
      assignFont = "BV Celine"
      textStyle = "uppercase"
    } else if (assignFont?.toLowerCase() === "seagram") {
      assignFont = "Seagramtfb";
    } else {
      assignFont = assignFont?.replace(/\s/g, "");
    }
    $(".fontPreviewCustomize").text(currentValue).css("font-family",assignFont).css('text-transform',textStyle);
  }
});

$.fn.maxlength.defaults = {
  template: "<div/>",
  showTemplate: true
};

function engravefont() {
  var maxlen = $('.line-item-property__field input.vow-form-control-light').attr('maxlength');
  if (typeof maxlen !== 'undefined' && maxlen !== false) {
    $(".line-item-property__field input.vow-form-control-light").maxlength({
      text: "{total}/{maxLength}",
    });
  }
  $(".template-product, .template-product .line-item-property__field input[name*='Heart'], .template-product input[name*='Name'], .template-product .line-item-property__field input[id*='text'] ").each(function () {
    var count = $(this).attr('maxlength');
    var label = $(this).attr('placeholder');
    if (typeof count !== 'undefined' && count !== false) {
      $(this).prev().append("0/" + count);
      $(this).parent().addClass("with-maxlength");
    }

    if (typeof label !== 'undefined' && label !== false) {
      $(this).after('<span class="label-text">' + label + '</span>');
    }
    $(".template-product .line-item-property__field input").on("click", function () {
      getFont(this);
    });
    $(".template-product input[name*='Name']").on("click", function () {
      getFont(this);
    })
    $(".template-product .line-item-property__field input").on("blur", function () {
      if ($(this).val() === '') {
        $(this).parent().removeClass('showlabel');
        $(this).removeClass("font-update");
        $(this).removeAttr('style');
      }
    });
    $(".template-product input[name*='Name']").on("blur", function () {
      if ($(this).val() === '') {
        $(this).parent().removeClass('showlabel');
        $(this).removeClass("font-update");
        $(this).removeAttr('style');
      }
    });
  });
}

/* As customization fields is rendering from script, we are using window.on load function here*/
$(window).on("load", function () {
  setTimeout(function () {
    if ($('span.label-text').length === 0) {
      engravefont();
    }
  }, 2000);
});

$('#customization').on('keyup', function () {
  previewCharacters()
  setConditionForCustomization(currentVariantJson);
  checkCharacterCountLeft();
});

/** Conditions for all products containing Customization field **/
function setConditionForCustomization(variant) {
  if (currentProductJson.options.includes('Engraving Font') == true) {
    var vals1 = getOptionsVals(variant, 'Engraving Font')
    if (vals1 && vals1 !== '' && ["Finish without engraving", "finish without engraving", "finished without engraving", "without engraving", "Without Engraving", "No Engraving", "no engraving"].indexOf(vals1) !== -1) {
      $('#customization').hide()
      $('#js-customization-required').addClass('hide')
      $('#customization').removeClass('required')
      $('#customization').attr('Valid', 'No')
      $('#customization').val('')
      $('#previewText').hide()
      $('#customization').removeAttr('name')
      $('#customization_count').removeAttr('name')
      $('.customization_required').removeAttr('name')
      $('.errormsg').hide();
      $('#Customization' + variant.id).removeClass('required')
      $('#customization').removeAttr("data-required")
    } else {
      $('#customization').show();
      $('#js-customization-required').removeClass('hide')
      $('#customization').addClass('required')
      $('#customization').attr('Valid', 'Yes')
      $('#previewText').show()
      $('#customization').attr('name', 'properties[Customization]')
      $('#customization_count').attr('name', 'properties[_Customization_Word_Count]')
      $('.customization_required').attr('name', 'properties[_Customization_Required]')
      $('#customization').attr("data-required", 'true')
      $('.errormsg').show();
    }
  }
  var optionIndex = $("#charCountCustomization").attr("index");
  var optionSelectedLetter = 0
  if(optionIndex) {
    optionSelectedLetter = variant["option" + optionIndex]
    $("#charCountCustomization").text("0/"+optionSelectedLetter)
    $("#customization").val("");
    $(".fontPreviewCustomize").text("");
  }
  var matches = currentProductJson.tags.filter(s => s.includes('c-'));
  if (currentProductJson.options.includes('Letter Count') == true) {
    var verifyCustomization = jQuery('#customization');
    var matches = currentProductJson.tags.filter(s => s.includes('c-'));
    var response = verifyCustomization.attr('maxlength')
    if (verifyCustomization && verifyCustomization.length == 1 && matches.length == 0 && response != 0) {
      if (verifyCustomization.val().length < response) {
        // jQuery('.customization-error').text('Please enter customization character to proceed.').removeClass('hide').addClass('open') /* RC-367 error message class update */
        // jQuery('.Cart__Checkout').attr('disabled', 'disabled')
        // jQuery('.ProductForm__AddToCart').attr('disabled', 'disabled')
      } else {
        jQuery('.Cart__Checkout').removeAttr('disabled', 'disabled')
        jQuery('.ProductForm__AddToCart').removeAttr('disabled', 'disabled')
        jQuery('.customization-error').text('Please enter customization character to proceed.').addClass('hide').removeClass('open')  /* RC-367 error message class update */
      }
      if (verifyCustomization.val().length > response) {
        jQuery('.customization-error').text('Please enter customization character to proceed.').removeClass('hide').addClass('open')  /* RC-367 error message class update */
        jQuery('.Cart__Checkout').attr('disabled', 'disabled')
        verifyCustomization.val("")
        $('.js-product-form-characters').html(`Characters Left: ${response}`);
      }
    }
  }
}

function previewCharacters(vals1) {
  var verifyCustomization = jQuery('#customization');
  if (verifyCustomization && verifyCustomization.length == 1) {
    var getCount = $('#customization').val().length;
    var getValue = $('#customization').val();
    $('#customization_count').val(getCount);
    $('#previewText').text(getValue);
    $('#previewText').empty(); // Clear any existing preview text
    if (vals1 && vals1 != 0) {
      // Reset previously applied font-family and letter-spacing styles
      $('#previewText').css({'font-family': '','letter-spacing': ''});
      if (vals1 == 'Bernhard Tango') {
        vals1 = 'BernhardTangoBT';
      }
      if (vals1 == 'AVERY' || vals1 == 'Arial-Black' || vals1 == 'Seagramftb') {
        $('#previewText').css('letter-spacing', '-3px !important')
      }
      $('#previewText').css('font-family', vals1.replaceAll(/\s/g, ''))
    }
  }
}

function checkCustomizationValues(variant) {
  var matches = currentProductJson.tags.filter(s => s.includes('c-'));
  if (currentProductJson.options.includes('Letter Count') == true) {
    var checkVariantAvail = getOptionsVals(variant, 'Letter Count')
    var getValue = $('#customization').val().length;
    var verifyCustomization = jQuery('#customization');
    verifyCustomization.attr('maxlength', checkVariantAvail)
    var getMaxLength = $('#customization').attr('maxlength');
    var finalValue = getMaxLength - getValue;
    if (checkVariantAvail == 1) {
      $('#customization_count').val(getValue);
    }
    else {
      $('#customization_count').val(getMaxLength);
    }
    $('.js-product-form-characters').html(`Characters Left: ${finalValue}`);
  }
  enableAddToCartButton();
}

function checkCharacterCountLeft() {
  var matches = currentProductJson.tags.filter(s => s.includes('c-'));
  if (currentProductJson.options.includes('Letter Count') == true) {
    var getValue = $('#customization').val().length;
    var getMaxLength = $('#customization').attr('maxlength');
    var finalValue = getMaxLength - getValue;
    $('.js-product-form-characters').html(`Characters Left: ${finalValue}`);
  }
  if (matches.length != 0) {
    var getValue = $('#customization').val().length;
    var getMaxLength = $('#customization').attr('maxlength');
    var finalValue = getMaxLength - getValue;
    $('#customization_count').val(getMaxLength);
    $('.js-product-form-characters').html(`Characters Left: ${finalValue}`);
  }
}

var engravableOptions = [];
function engravableOptionsDropdownArray() {
  for (var i = 0; i < currentProductJson.tags.length; i++) {
    if (currentProductJson.tags[i].indexOf('Font-') > -1) {
      engravableOptions.push(currentProductJson.tags[i].replace("Font-", ""))
    }
  }
}

/* Engravable DropDown */
function engravableDropDown(v) {
  jQuery('#engravable').html("");
  var htmlDiv = ''
  if (v) {
    htmlDiv += `<div class="ProductForm__Option engravable-dropdown disabled_fields">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-engravable-dropdown-options" type="button" class="ProductForm__Item engravable_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-engravable-dropdown-options" disabled="disabled">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">Font </span><span class="ProductForm__SelectedValueEngravable` + v.id + ` dropdown-selected-value">Select</span></span>`
    htmlDiv += `<input type="hidden" id="engravingFont" name="properties[Engraving_Font]" class="engravable_option_value` + v.id + `_selectedvalue" value=''>`;
    htmlDiv += `<input type="hidden" id="engravingText" name="properties[Engraving_Text]"  value="">`;
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-engravable-dropdown-options" class="OptionSelector engravable_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Engravable</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList engravable-dropdown" data-scrollable="">`;
    for (var j = 0; j < engravableOptions.length; j++) {
      var variant = engravableOptions[j];
      var textTransform = "";
      if (variant === "Bernhard Tango") {
        fontFamily = "BernhardTangoBT"
      } else if (variant === "Celine") {
        fontFamily = "BV Celine";
        textTransform = "uppercase";
      } else {
        fontFamily = variant.replace(/\s/g, "");
      }
      htmlDiv += `<button type="button" class="engravable_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant + `" data-value="` + variant + `"  style="font-family:` + fontFamily + `; text-transform:` + textTransform + `">`;
      htmlDiv += `<span class="dropdown-title">` + variant + `</span>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    jQuery('#engravable').append(htmlDiv)
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionEngravable()
    stopScreenFreeze()
    /* Show Engraving Toggle */
    $('#engravablesInputsWrapperSlider').removeClass('hide')
  } else {
    console.log("option2 is not a number")
  }
}

function engravablePlacementDropDown(v, engravablePlacementJson){
  jQuery('#engravable_placement').html("");
  var htmlDiv = ''
  var checkEngravingStyleOptions = currentProductJson.tags.filter(s => s.includes('engraving-style-options'));
  var checkEngravingPlacementOptions = currentProductJson.tags.filter(s => s.includes('engraving-placement-options'));
  var placementName = "Engravable Placement"

  if (checkEngravingStyleOptions && checkEngravingStyleOptions.length){
    engravablePlacementJson = engravingStyleOptions
    placementName = "Engraving Placement"
  }
  if (checkEngravingPlacementOptions && checkEngravingPlacementOptions.length){
    engravablePlacementJson = engravingPlacementeOptions
    placementName = "Engraving Placement"
  }
  
  if (v) {
    htmlDiv += `<div class="ProductForm__Option engravable-placement-dropdown disabled_fields">`;
    htmlDiv += `<button id="btn-popover-` + v.id + `-product-template-engravable-placement-dropdown-options" type="button" class="ProductForm__Item engravable_placement_drop_down" aria-expanded="false" aria-controls="popover-` + v.id + `-product-template-engravable-placement-dropdown-options" disabled="disabled">`;
    htmlDiv += `<span class="ProductForm__OptionName"><span class="dropdown-lable">` + placementName + `</span><span class="ProductForm__SelectedValueEngravablePlacement` + v.id + ` dropdown-selected-value">Select</span></span>`
    htmlDiv += `<svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">`;
    htmlDiv += `<polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>`;
    htmlDiv += `</svg>`;
    htmlDiv += `</button>`;
    htmlDiv += `<div id="popover-` + v.id + `-product-template-engravable-placement-dropdown-options" class="OptionSelector engravable_placement_dropdown_popover Popover Popover--withMinWidth option-new-style Popover--positionLeft Popover--alignCenter" aria-hidden="true" tabindex="-1">`;
    htmlDiv += `<header class="Popover__Header">`;
    htmlDiv += `<button type="button" class="Popover__Close Icon-Wrapper--clickable" data-action="close-popover"><svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">`;
    htmlDiv += `<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>`;
    htmlDiv += `</svg></button>`;
    htmlDiv += `<span class="Popover__Title Heading u-h4">Engravable Placement</span>`;
    htmlDiv += `</header>`
    htmlDiv += `<div class="Popover__Content">`;
    htmlDiv += `<div class="Popover__ValueList engravable-placement-dropdown" data-scrollable="">`;
    for (var j = 0; j < engravablePlacementJson.length; j++) {
      var variant = engravablePlacementJson[j];
      htmlDiv += `<button type="button" class="engravable_placement_dropdown_variant_option Popover__Value  Heading Link Link--primary u-h6" oldId="` + v.id + `" index="` + j + `" data-title="` + variant + `" data-value="` + variant + `" >`;
      htmlDiv += `<span class="dropdown-title">` + variant + `</span>`;
      htmlDiv += `</button>`;
    }
    htmlDiv += `</div>`;
    htmlDiv += `</div>`;
    htmlDiv += `</div></div>`;

    jQuery('#engravable_placement').append(htmlDiv)
    $('body').css("overflow", "visible");
    /* Enabling Add to cart button */
    enableAddToCartButton()
    setClickActionEngravablePlacement()
    // previewColorCombinationButton("_engraving_image")
    stopScreenFreeze()
    /* Show Engraving Toggle */
    $('#engravablesInputsWrapperSlider').removeClass('hide')
  } else {
    console.log("option2 is not a number")
  }
}

function setClickActionEngravable() {
  jQuery(".engravable_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        if (pos.top > 650) {
          tops = pos.top + 20 - scrollHeight
        } else {
          tops = pos.top - 120 - scrollHeight
        }
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }

      var checkEngravingStyleOptions = currentProductJson.tags.filter(s => s.includes('engraving-style-options'))
      var checkEngravingPlacementOptions = currentProductJson.tags.filter(s => s.includes('engraving-placement-options'))
    
      if (checkEngravingPlacementOptions.length && windowWidth > 1024) tops = pos.top - 0 - scrollHeight
      if (checkEngravingStyleOptions.length && windowWidth > 1024) tops = pos.top - 0 - scrollHeight
      
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}

function setClickActionEngravablePlacement() {
  jQuery(".engravable_placement_drop_down").click(function () {
    var id = $(this).attr('id')
    jQuery(".Popover--withMinWidth").each(function () {
      var ids = `btn-` + $(this).attr('id')
      if ($(this).attr('aria-hidden') === 'false' && ids !== id) {
        jQuery(".Popover--withMinWidth").attr('aria-hidden', true)
      }
    })
    var pos = jQuery("#" + id).offset()
    var windowWidth = jQuery(document).width()
    var scrollHeight = $(window).scrollTop()
    var tops = 0
    if (pos && id) {
      var right = (windowWidth - pos.left + 20);
      var left = (windowWidth - pos.right + 20);
      var rightLeft = true
      if (windowWidth > 1024) {
        if (pos.top > 650) {
          tops = pos.top - 50 - scrollHeight
        } else {
          tops = pos.top - 120 - scrollHeight
        }
      } else if (windowWidth === 1024) {
        rightLeft = false
        tops = pos.top - 140 - scrollHeight
      } else if (windowWidth > 768 && windowWidth < 1024) {
        tops = pos.top - 140 - scrollHeight
      } else {
        $(".PageOverlay").addClass('is-visible')
        tops = windowWidth - 140
      }
      
      var checkEngravingStyleOptions = currentProductJson.tags.filter(s => s.includes('engraving-style-options'))
      if (checkEngravingStyleOptions.length && windowWidth > 1024) tops = pos.top - 0 - scrollHeight
      
      var divid = id.replace('btn-', '')
      var sts = jQuery("#" + divid).attr('aria-hidden')
      if (sts.toString() === "true") {
        if (windowWidth > 768) {
          jQuery("#" + divid).attr('aria-hidden', false).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', false)
        }
        jQuery("#" + id).attr('aria-expanded', true)
      } else {
        if (rightLeft) {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, right: right })
        } else {
          jQuery("#" + divid).attr('aria-hidden', true).css({ top: tops, left: left })
        }
        jQuery("#" + id).attr('aria-expanded', false)
      }
    }
  })
  popoverClosed()
}